export const isValidMMDDYYYY = (dateStr) => {
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/
  if (!regex.test(String(dateStr || ''))) return false

  const [month, day, year] = String(dateStr).split('/')
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  return date && date.getMonth() + 1 === parseInt(month) && date.getDate() === parseInt(day) && date.getFullYear() === parseInt(year)
}

export const parseMMDDYYYYDate = (str) => {
  const [month, day, year] = String(str || '').split('/')
  return new Date(Number(year), Number(month) - 1, Number(day))
}

export const formatDateToMMDDYYYY = (date) => {
  if (!date) return ''
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const yyyy = date.getFullYear()
  return `${mm}/${dd}/${yyyy}`
}

export const parseUSDateValue = (value) => {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const raw = String(value).trim()
  if (!raw) return null

  if (isValidMMDDYYYY(raw)) {
    return parseMMDDYYYYDate(raw)
  }

  const datePart = raw.split('T')[0].trim()
  const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (isoMatch) {
    const [, year, month, day] = isoMatch
    const parsed = new Date(Number(year), Number(month) - 1, Number(day))
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }

  const slashMatch = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  if (slashMatch) {
    const [, month, day, year] = slashMatch
    const usParsed = new Date(Number(year), Number(month) - 1, Number(day))
    if (!Number.isNaN(usParsed.getTime()) && usParsed.getMonth() + 1 === Number(month) && usParsed.getDate() === Number(day)) {
      return usParsed
    }

    const fallbackParsed = new Date(Number(year), Number(day) - 1, Number(month))
    if (!Number.isNaN(fallbackParsed.getTime())) return fallbackParsed
  }

  const parsed = new Date(raw)
  if (Number.isNaN(parsed.getTime())) return null

  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
}

export const formatValueToMMDDYYYY = (value) => {
  const parsed = parseUSDateValue(value)
  return parsed ? formatDateToMMDDYYYY(parsed) : ''
}

export const formatValueToISODate = (value) => {
  const parsed = parseUSDateValue(value)
  if (!parsed) return ''

  const year = parsed.getFullYear()
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const day = String(parsed.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const areSameDateValues = (leftValue, rightValue) => {
  const leftParsed = parseUSDateValue(leftValue)
  const rightParsed = parseUSDateValue(rightValue)

  if (!leftParsed || !rightParsed) return false

  return (
    leftParsed.getFullYear() === rightParsed.getFullYear() &&
    leftParsed.getMonth() === rightParsed.getMonth() &&
    leftParsed.getDate() === rightParsed.getDate()
  )
}
